import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import { useAuth } from "../../provider/AuthProvider";
import "./Character.scss";
import CharacterFull from "../../components/character/CharacterFull";
import CharacterUsedXP from "../../components/character/CharacterUsedXP";
import CharacterUpdate from "../../components/character/CharacterUpdate";
import CharacterDelete from "../../components/character/CharacterDelete";

const Character = () => {
  const { isAdmin, userId, isMJ } = useAuth();
  const { idCharacter } = useParams();
  const [character, setCharacter] = useState();
  const [isUsedXP, setIsUsedXP] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setIsUsedXP(false);
    setIsUpdate(false);
    setIsDelete(false);
    setRefresh(false);
    setTimeout(() => {
      api
        .get(`/character/${idCharacter}/`)
        .then((response) => {
          setCharacter(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }, 500);
  }, [refresh]);

  return (
    <div className="character">
      {isLoading && (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      )}
      {!isLoading && character == null && (
        <div className="no-data">
          <p>
            <strong>Personnage introuvable</strong>
          </p>
        </div>
      )}
      {!isLoading && character && (
        <>
          {isUsedXP && (
            <>
              <CharacterUsedXP
                character={character}
                setIsUsedXP={setIsUsedXP}
                setRefresh={setRefresh}
              />
            </>
          )}

          {(isAdmin || isMJ) && isUpdate && (
            <>
              <CharacterUpdate
                character={character}
                setIsUpdate={setIsUpdate}
                setRefresh={setRefresh}
              />
            </>
          )}

          {isDelete && (
            <>
              <CharacterDelete
                character={character}
                setIsDelete={setIsDelete}
              />
            </>
          )}

          {!isUpdate && !isDelete && !isUsedXP && (
            <>
              <CharacterFull
                isAdmin={isAdmin}
                userId={userId}
                isMJ={isMJ}
                character={character}
                setIsUsedXP={setIsUsedXP}
                setIsUpdate={setIsUpdate}
                setIsDelete={setIsDelete}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Character;
